import { css } from '@emotion/react'

const noviceThumbStyling = css`
  .PAPER {
    position: relative;
    bottom: 120px;
    left: 10px;
    @media (max-width: 1366px) {
      bottom: 80px;
      right: 70px;
    }
  }
  .ROCK {
    position: relative;
    bottom: 120px;
    left: 140px;
    @media (max-width: 1366px) {
      bottom: 80px;
      left: 90px;
    }
  }
  .SCISSORS {
    position: relative;
    top: 100px;
    right: 160px;
    @media (max-width: 1366px) {
      top: 70px;
      right: 100px;
    }
  }
`

const proThumbStyling = css`
  .PAPER {
    position: relative;
    bottom: 40px;
    left: 140px;
    @media (max-width: 1366px) {
      bottom: 20px;
      left: 100px;
    }
  }
  .ROCK {
    position: relative;
    bottom: 150px;
    left: 160px;
    @media (max-width: 1366px) {
      bottom: 110px;
      left: 100px;
    }
  }
  .SCISSORS {
    position: relative;
    bottom: 40px;
    left: 170px;
    @media (max-width: 1366px) {
      bottom: 20px;
      left: 100px;
    }
  }

  .LIZARD {
    position: relative;
    top: 160px;
    right: 270px;
    @media (max-width: 1366px) {
      top: 110px;
      right: 160px;
    }
  }
  .SPOCK {
    position: relative;
    top: 160px;
    right: 200px;
    @media (max-width: 1366px) {
      top: 110px;
      right: 130px;
    }
  }
`

export { noviceThumbStyling, proThumbStyling }
